//=====================================================
//　テキストボックスベース
//=====================================================

import { useFormContext } from "react-hook-form"

interface IFProps {
    name: string,
    className: string,
    placeholder?: string,
    validations?: {},
    type?: string
}

export function InputTextBase(props: IFProps) {

    const cf = useFormContext();

    //クラス名設定。対象にエラーがある場合はis-errorを付与。
    let tmpClass = props.className;
    if (cf.formState.errors[props.name]){
        tmpClass = tmpClass + " is-error";
    }

    //type判定
    let tmpType = props.type;
    if (!tmpType) {
        tmpType = "text";
    }

    return (
        <input type={tmpType} autoComplete="off" id={props.name} className={tmpClass} placeholder={props.placeholder} {...cf.register(props.name, props.validations)}></input>
    )

}